import TeamPhotoExclusionNotice from './TeamPhotoExclusionNotice';

export default TeamPhotoExclusionNotice;
